import React, { useEffect, useState } from "react";
import axios from "axios";

const AboutUs = () => {
  const [blogs, setblogs] = useState([]);
  const team = [
    {
      name: "PETER FAJEMISIN",
      position: "The Visionary",
      info: "Peter Fajemisin is the founder and CEO at Ileero where he deploys his wealth of experience and deep technical knowledge to provide strategic leadership in pursuit of the company’s vision and mission. His passion for technology as a tool for solving everyday problems has spurred him to set up ventures that provide simple solutions to complex problems through electronic channels and digital platforms. A  seasoned  entrepreneur  and  forward-thinking  executive,  Peter  combines  his  rich  professional background  with  field-tested  knowledge  of  market  intelligence,  business  strategy  and  cultural awareness to facilitate financial inclusion and payment innovation.",
      picture:
        "https://ileeroremit.s3.eu-west-2.amazonaws.com/our-team/peter.jpg",
    },
    {
      name: "OMOLAYO ODUPE",
      info:'With broad  and  deep  experience  and  knowledge  in  sales,  business  development,  payments, partnerships and leadership, Omolayo oversees, identifying new business opportunities, cultivating business relationships, partnerships  and people management.',
      position: "The Grower",
      picture:
        "https://ileeroremit.s3.eu-west-2.amazonaws.com/our-team/omolayo.jpg",
    },
    {
      name: "CHRISTIANA EKE-CHRIS",
      position: "The Guide",
      info:'At the center of Ileero’s client journey is Christiana, driving strategies to deepen relationships with customers and  enhance organizational effectiveness. She  leads Ileero’ customer  engagement and enablement strategy enhancing customer’s satisfaction, value and accelerating growth.',
      picture:
        "https://ileeroremit.s3.eu-west-2.amazonaws.com/our-team/christy.jpg",
    },
    {
      name: "JOSEPH AJAYI",
      position: "The Architect",
      info:'A technology  expert with technology capabilities garnered over 10 years of experience spanning Software and application development, IT Infrastructure in payment and fintech industry. At Ileero, Joseph leads a team of developers championing research and development of Ileero’s payment gateway solutions to varied market segments, ensuring the delivery of a robust platform with strong support for customers.',
      picture:
        "https://ileeroremit.s3.eu-west-2.amazonaws.com/our-team/joseph.jpg",
    },
    {
      name: "OMOTAYO EDDO",
      position: "The broadcaster",
      info:'Omotayo distinction lies in delivering winning strategies and campaigns across all the digital platforms driving growth, engagement and loyalty. With strong track record of developing game-changing ideas with successful implementation, he is responsible for product marketing and communication.',
      picture:
        "https://ileeroremit.s3.eu-west-2.amazonaws.com/our-team/omotayo.jpg",
    },
    {
      name: "SHOLA AJAYI",
      position: "The Optic",
      info:'Shola Ajayi is a senior graphic design and specialist with over 6years of experience in digital storytelling, management of design process, from conceptualization to delivery. Shola handles all task related to design, product strategy and ensuring the company continues to offer a best-in-class user experience.',
      picture:
        "https://ileeroremit.s3.eu-west-2.amazonaws.com/our-team/shola.jpg",
    },
    {
      name: "ELISHA OGADA",
      position: "The Plug",
      info:'Elisha is responsible for leading Ileero business forward in the East Africa region, driving expansion and strategic partnership. Also, in his role providing support for the company, he oversees the coordination of various projects, product and strategic initiatives necessary to drive the company’s vision.',
      picture:
        "https://ileeroremit.s3.eu-west-2.amazonaws.com/our-team/elisha.jpg",
    },
  ];

  const getBlogs = async () => {
    const res = await axios.get(
      "https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@ileeroremit"
    );
    setblogs(res.data.items ?? []);
    console.log(res.data.items);
  };

  useEffect(() => {
    getBlogs();
  }, []);

  return (
    <div>
      <section className="row about-us-hero-section align-items-center">
        <div className="col-lg-6 p-lg-5 p-3">
          <h2 className="text-white ">
            Ileero was launched in 2021 with the vision of making international
            money transfers cheap, fair, and simple. Today, our multi-currency
            account helps millions of people and businesses manage their money
            across the world. Here’s how we got here.
          </h2>
        </div>
      </section>

      <section className="bg-light">
        <div className="container py-5">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <iframe
                width="100%"
                height="100%"
                frameBorder="0"
                src={`https://www.youtube.com/embed/kqaQ_shHFO0?controls=1`}
              ></iframe>
            </div>
            <div className="col-lg-6">
              <h3>Our Story</h3>
              <p>
                Download our app for free to send money online in minutes. Track
                your payments and view your transfer history from anywhere.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="container my-5">
        <h3>Our Team</h3>
        <div className="row">
          {team.map((member, index) => (
            <div className="col-lg-6 my-5" key={index}>
              <div className="row align-items-center">
                <div className="col-lg-3 mb-4">
                  <img
                    src={member.picture}
                    alt=""
                    height={100}
                    width={100}
                    className="rounded-circle"
                  />
                </div>
                <div className="col-lg-9  mb-4">
                  <p className="m-0 font-weight-bold">{member.name}</p>
                  <small>{member.position}</small>
                </div>
              </div>
              <p>
                {member.info}
              </p>
            </div>
          ))}
        </div>
      </section>

      <section className="my-5 bg-light py-5">
        <div className="container-fluid">
          <h3 className="text-center my-5">Latest News</h3>

          <div className="row">
            {blogs?.map((blog: any, index) => (
              <div className="col-lg-4" key={index}>
                <img
                  src={blog?.thumbnail}
                  style={{
                    width: "100%",
                    height: "360px",
                    objectFit: "cover",
                    borderRadius: "10px",
                  }}
                />
                <h6 className="my-3">{blog.title}</h6>
                <a href={blog.link} target="_blank" rel="noopener noreferrer">
                  Read
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
